import { useAtom, useSetAtom } from 'jotai';

import {
  askSynclyFilterAtom,
  type OverrideAskSynclyFilter,
} from '../../chat/atoms/ask-syncly-filter-atom';
import { sidebarStateAtom } from '../../chat/atoms/sidebar-state-atom';

export function useAddFilterToAskSyncly() {
  const setAskSynclyFilter = useSetAtom(askSynclyFilterAtom);
  const [sidebarState, setSidebarState] = useAtom(sidebarStateAtom);

  return (filter: OverrideAskSynclyFilter) => {
    setAskSynclyFilter(filter);
    setSidebarState({ ...sidebarState, isOpen: true });
  };
}
